import AuthCurrentTenant from 'src/modules/auth/authCurrentTenant';
import {getSelectableDivisionIds} from 'src/modules/auth/currentDivisionScope';
import service from 'src/modules/auth/authService';

const FP_STORAGE_KEY = 'latestSearchesScopeFp';

export function computeLatestSearchesAccessFingerprint(
  currentUser: any,
  tenantId: string | null,
  tenantAccessContext: any,
): string {
  if (!tenantId || !currentUser?.tenants) {
    return '';
  }
  const tu = currentUser.tenants.find((t: any) => t?.tenant?.id === tenantId);
  if (!tu) {
    return '';
  }
  const rolesRaw = (tu.roles || []) as unknown[];
  const roles = rolesRaw.map((r) => String(r)).filter(Boolean).sort().join('\u0001');
  const divs = getSelectableDivisionIds(tenantAccessContext).slice().sort().join('\u0001');
  return `${roles}\u0002${divs}`;
}

export function readStoredLatestSearchesAccessFingerprint(): string | null {
  const v = AuthCurrentTenant.getItem(FP_STORAGE_KEY, 'null');
  return typeof v === 'string' && v.length > 0 ? v : null;
}

function writeStoredLatestSearchesAccessFingerprint(fp: string) {
  if (!fp) {
    AuthCurrentTenant.removeItem(FP_STORAGE_KEY);
    return;
  }
  AuthCurrentTenant.setItem(FP_STORAGE_KEY, fp);
}

export function clearLatestSearchesLocalCache() {
  AuthCurrentTenant.removeItem('latestSearches');
}

/** Cola en el macrotask; errores silenciados para no romper flujo de auth/UI. */
export function scheduleSyncLatestSearchesClearToServer() {
  setTimeout(() => {
    void (async () => {
      try {
        await service.clearAllLatestSearches();
      } catch {
        // Sin toast: limpieza best-effort tras cambio de alcance
      }
    })();
  }, 0);
}

/**
 * Actualiza la huella guardada. Si el alcance cambió respecto a la última sesión guardada,
 * vacía caché local y pide al servidor borrar latestSearches.
 * @returns true si se invalidó la caché de últimas búsquedas
 */
export function syncLatestSearchesAccessFingerprintAndMaybeInvalidate(nextFp: string): boolean {
  if (!nextFp) {
    clearLatestSearchesLocalCache();
    AuthCurrentTenant.removeItem(FP_STORAGE_KEY);
    return false;
  }
  const prev = readStoredLatestSearchesAccessFingerprint();
  let invalidated = false;
  if (prev != null && prev !== nextFp) {
    clearLatestSearchesLocalCache();
    scheduleSyncLatestSearchesClearToServer();
    invalidated = true;
  }
  writeStoredLatestSearchesAccessFingerprint(nextFp);
  return invalidated;
}
